import requests from "./httpService";

const CityLinkServices = {

   getAllCityLink: async () => {
    return requests.get("/cities/all");
  },

  // Get CityLink by ID
  getCityLinkById: async (id) => {
    return requests.get(`/cities/${id}`);
  },

  // Generate encrypted link for a CityLink
  generateCityLink: async (id) => {
    return requests.get(`/cities/generate-link/${id}`);
  },
};

export default CityLinkServices;
